import React, { useContext } from 'react';

import HelpMessage from './HelpMessage';
import Form from 'react-bootstrap/Form';
import LocaleContext from 'constants/localization';

export default function Header({ field, mode, type }) {
  const HEADER_STYLE = {textWrap: 'balance', overflowWrap: 'break-word', wordBreak: 'break-all'};
  const { predicate, label, props } = field;
  let help = null;

  if (props) {
    if (props.noHeader) {
      return null;
    }
    else if (props.help) {
      help = props.help;
    }
  }

  if (!type) {
    type = 'field';
  }
  if (!mode) {
    mode = '';
  }
  else if (mode === 'no-header') {
    return null;
  }

  let style = `${type}-header ${mode}`;
  return (
    <div className={`header flex-left ${mode}`}>
      <Form.Label style={HEADER_STYLE} className={style}>{label}</Form.Label>
      <HelpMessage help={help} predicate={predicate} />
      <FieldValueWarning field={field} />
    </div>
  );
}

// SPEC-473 max display value limit
const FieldValueWarning = ({ field }) => {
  const LS = useContext(LocaleContext);
  const [isShown, setIsShown] = React.useState(false);

  if (!field?.props?.valueLimitReached) {
    return null;
  }

  const warningIcon = '\u{26A0}';

  return (
    <span className="info-hover"
      style={{fontStyle: 'italic'}}
      onMouseEnter={() => setIsShown(true)}
      onMouseLeave={() => setIsShown(false)}
    >
      {warningIcon}
      { isShown && <span> {LS.warning.valueLimitReached} </span>}
    </span>
  );
};